var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/heart"),React.createElement("g",{"id":"icon/heart","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M16,27 L27.8129538,16.4239353 L27.8129538,16.4117545 C30.7290154,13.8010615 30.7290154,9.56858224 27.8129538,6.95788924 C24.8970803,4.34737025 20.1694548,4.34737025 17.2535812,6.95788924 C16.7471103,7.41153696 16.3305033,7.91477792 16,8.44916692 C15.6694967,7.91477792 15.2527017,7.41153696 14.7464188,6.95788924 C11.8305452,4.34737025 7.1029197,4.34737025 4.18704616,6.95788924 C1.27098461,9.56858224 1.27098461,13.8010615 4.18704616,16.4117545 L4.18704616,16.4239353 L16,27 Z","id":"Stroke-12","stroke":"#1C1754","strokeWidth":"3"}))]);
}

Heart.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 32 32","version":"1.1"};

module.exports = Heart;

Heart.default = Heart;
